<template>
  <!-- 影像上传（4） -->
  <div class="supplementary" style="padding-bottom: 0.65rem;">
    <div class="li-content">
      <div class="border-style">
        <h3>影像信息</h3>
        <div class="tabs-choose">
          <div
            v-for="(item, index) in tabsContent"
            :key="index"
            class="each-tab"
            :class="{ active: item.active }"
            @click="showMore(item, index)"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
      <div
        v-for="(item, key) in tabsContent"
        v-show="item.state"
        :key="key"
        class="border-style"
      >
        <h3>{{ item.text }}</h3>
        <div class="img-choose">
          <div
            v-for="(item, index) in tabsContent[key].src"
            :key="index"
            class="img-content"
          >
            <img
              class="delete-img"
              :src="deleteImg"
              alt=""
              @click="IMGRemove(item, key, index)"
            >
            <img class="downLoad-img" :src="imgUrl + item.path" alt="">
          </div>
          <div
            v-if="tipVisible"
            class="img-content"
            @change="handleFile($event, key)"
          >
            <input ref="fileBtn" type="file" multiple accept="image/*">
            <img class="downLoad-img" :src="imgUrlIcon" alt="">
          </div>
          <div v-if="tipVisibles" class="img-content" @click="handleFiles(key)">
            <img class="downLoad-img" :src="imgUrlIcon" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="li-content">
      <div class="border-style" @click="goSpecial">
        <mt-cell class="title-weight" title="特别约定" is-link />
      </div>
    </div>

    <!-- 健康问询 -->
    <div v-show="isShowHeal" class="li-content">
      <div class="border-style">
        <mt-cell class="title-weight" title="健康问询">
          <div v-if="showReload" class="reload">
            <van-icon name="replay" />
            <span
              :style="{ fontSize: '0.14rem' }"
              @click="reload"
            >刷新状态</span>
          </div>

          <div class="share">
            <van-icon name="share-o" />
            <span
              :style="{ fontSize: '0.14rem' }"
              @click="share"
            >确认分享</span>
          </div>
        </mt-cell>
        <div class="context">
          <div v-if="healthList" class="context_m">
            <div
              v-for="(item, index) in healthList"
              :key="index"
              class="context_li"
            >
              <div>{{ item.title }}</div>
              <div v-if="item.icon">
                <van-icon v-if="item.status" name="passed" />
                <van-icon v-else name="close" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="li-content">
      <div class="border-style">
        <h3 style="border-bottom: 1px solid #999999">
          备注说明
        </h3>
        <textarea
          v-model="remark"
          class="input-style"
          type="text"
          maxlength="500"
          placeholder="请输入备注信息，信息将在核保时展示"
        />
      </div>
    </div>
    <div class="next-step">
      <button class="save-btn" @click="save(true, true, 1)">
        暂存
      </button>
      <button @click="goNext">
        提交核保
      </button>
    </div>
    <div v-if="frame" class="ErrorTips">
      <div class="Bottoming">
        <div class="Bottoming-top" v-html="analysis">
          <div />
          {{ analysis }}
        </div>
        <div class="Bottoming-buttom" @click="determination">
          确定
        </div>
      </div>
    </div>
    <Loading :switchs="switchs" />
    <van-popup v-model="popupVisible" position="bottom" close-on-click-overlay>
      <van-picker
        :columns="columns"
        show-toolbar
        @confirm="onConfirm"
        @cancel="popupVisible = false"
      />
    </van-popup>

    <!-- 微信分享模板 -->
    <div v-show="isWX" class="wx" @click="isWX = false">
      <img class="WXimg" :src="isWXPic" alt="">
    </div>

    <!-- 提交核保弹框 -->
    <van-dialog
      v-model="ShowVandialog"
      show-cancel-button
      cancel-button-text="暂不提交"
      confirm-button-text="提交其他产品"
      confirm-button-color="#5E2589"
      @confirm="submit"
    >
      <div class="sub_div">
        您好,{{ dialogText }}（或客户未确认）是否继续提交其他产品
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant'
import api from '@/api/api.js'
import checkFormat from '@/utils/checkFormat.js'
import Loading from '@/components/Loadings/Loading'
export default {
  components: {
    Loading: Loading,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      devUrl: api.devUrl,
      imgUrl: api.imgIdUrl,
      frame: false,
      switchs: false,
      tipVisible: false, // 其他进入
      tipVisibles: false, // APP 进入
      imgUrlIcon: api.imgAllUrl + '/sales400709.png',
      imgUrlExample: api.imgAllUrl + '/sales180709.png',
      deleteImg: api.imgAllUrl + '/sales240709.png',
      switchValue: false,
      active: false,
      fileIdList: [],
      tabsContent: [
        // {
        //   text: "验车照",
        //   fileType: "1",
        //   state: false,
        //   show: false,
        //   src: []
        // },
        // {
        //   text: "车辆证件",
        //   fileType: "2",
        //   state: false,
        //   show: false,
        //   src: []
        // },
        // {
        //   text: "客户证件",
        //   fileType: "3",
        //   state: false,
        //   show: false,
        //   src: []
        // },
        // {
        //   text: "购车证明",
        //   fileType: "4",
        //   state: false,
        //   show: false,
        //   src: []
        // },
        // {
        //   text: "过户证明",
        //   fileType: "5",
        //   state: false,
        //   show: false,
        //   src: []
        // },
        // {
        //   text: "退保证明",
        //   fileType: "6",
        //   state: false,
        //   show: false,
        //   src: []
        // },
        // {
        //   text: "单证",
        //   fileType: "7",
        //   state: false,
        //   show: false,
        //   src: []
        // },
        // {
        //   text: "申请书",
        //   fileType: "8",
        //   state: false,
        //   show: false,
        //   src: []
        // },
        // {
        //   text: "其他",
        //   fileType: "9",
        //   state: false,
        //   show: false,
        //   src: []
        // }
      ],
      deliveryInfo: {
        receivePhone: '',
        receiver: '',
        receiverAddress: '',
        receiverMail: ''
      },
      // 影像信息参数
      yxparam: {
        imageInfoList: [],
        orderId: ''
      },
      arr: '', // 特约返回数据
      keys: 0,
      analysis: '', // 提示内容
      jumpStatus: 0,
      popupVisible: false,
      networkCode: '',
      columns: [],
      // network: false
      remark: '',
      healthList: [
        // {title:'《个人重大疾病（2021版）健康问询》',state:false,icon:false,},
        // {title:'《靶向医疗保险（2020版）健康问询》',state:false,icon:false,},
        // {title:'《靶向医疗保险（2020版）健康问询》',state:false,icon:false,},
        // {title:'《靶向医疗保险（2020版）健康问询》',state:false,icon:false,},
      ], // 健康问询
      icon: true, // 图标显示
      showReload: false, // 刷新按钮
      isWXPic: './static/image/share.png',
      isWX: false,
      ShowVandialog: false,
      dialogText: '',
      proList: [],
      proTemp: [],
      flag: '',
      shareLogo: api.imgAllUrl + '/wxLogo20210616.png',
      isShowHeal: false
    }
  },
  computed: {},
  watch: {},
  mounted() {
    function onBridgeReady() {
      // 通过下面这个API显示右上角按钮
      WeixinJSBridge.call('showOptionMenu')
    }

    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }

    window.__proto__.once = 1
    // if (localStorage.getItem('setChannelCode') === 'ZKICATM') {
    //   this.network = true
    // }
    window.handleFiles = this.handleFiles
    window.pickImageBack = this.pickImageBack
    // let URL = window.location.href
    // if(URL.indexOf('terminalId=APP') !== -1) {
    //   this.tipVisibles = true
    //   this.tipVisible = false
    // } else {
    //   this.tipVisible = true
    //   this.tipVisibles = false
    // }
    this.tipVisible = true
    this.tipVisibles = false
    const param = {
      url: window.location.href.split('#')[0],
      wxType: '5'
    }
    this.$http
      .post(api.getWxTicket, param)
      .then(res => {
        wx.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: api.appId, // 必填，企业微信的corpID
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: ['updateAppMessageShareData', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        })
      })
      .catch(error => {
        console.log(error)
      })
  },
  activated() {
    this.proList = []
    this.proTemp = []
    this.$store.state.productXInfoDTOList.forEach(item => {
      if (item.flag == true) {
        this.proList.push(`"${item.productCode}"`)
      }
    })
    this.$store.state.productXInfoDTOList.forEach(item => {
      console.log(item.flag)
      if (item.flag == true) {
        this.proTemp.push(item.productCode)
      }
    })
    if (this.proTemp.length > 0) {
      this.isShowHeal = true
    } else {
      this.isShowHeal = false
    }
    // 获取影像资料排序
    this.getContentTabs()
    this.queryList()
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.$store.commit('setStep', '4')
    this.$store.commit('setShow', true)
    this.arr = this.$route.params.arr
    // if (this.$store.state.entrance === 0) {
    //   this.tabsContent = [
    //     {
    //       text: "验车照",
    //       fileType: "1",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     },
    //     {
    //       text: "车辆证件",
    //       fileType: "2",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     },
    //     {
    //       text: "客户证件",
    //       fileType: "3",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     },
    //     {
    //       text: "购车证明",
    //       fileType: "4",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     },
    //     {
    //       text: "过户证明",
    //       fileType: "5",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     },
    //     {
    //       text: "退保证明",
    //       fileType: "6",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     },
    //     {
    //       text: "单证",
    //       fileType: "7",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     },
    //     {
    //       text: "申请书",
    //       fileType: "8",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     },
    //     {
    //       text: "其他",
    //       fileType: "9",
    //       state: false,
    //       show: false,
    //       active: false,
    //       src: []
    //     }
    //   ];
    //   this.fileIdList = [];
    //   if (
    //     this.$store.state.itemFileDataList &&
    //     this.$store.state.itemFileDataList.length > 0 &&
    //     this.$store.state.itemFileDataList[0].fileList &&
    //     this.$store.state.itemFileDataList[0].fileList.length > 0
    //   ) {
    //     this.$store.state.itemFileDataList[0].fileList.forEach(value => {
    //       let fileStreams = value.fileId;
    //       let obj = {
    //         path: fileStreams
    //       };
    //       this.tabsContent[Number(value.fileType) - 1].src.push(obj);
    //       this.tabsContent[Number(value.fileType) - 1].state = true;
    //       if (
    //         value.fileType ===
    //         this.tabsContent[Number(value.fileType) - 1].fileType
    //       ) {
    //         this.tabsContent[Number(value.fileType) - 1].active = true;
    //       }
    //       let objs = {
    //         fileId: value.fileId,
    //         fileType: value.fileType
    //       };
    //       this.fileIdList.push(objs);
    //     });
    //   }
    // }
  },
  deactivated() {
    Toast.clear()
    this.$store.commit('setStep', '')
  },
  methods: {
    getContentTabs() {
      const params = {
        codeType: 'DocumentsType'
      }
      this.$http.post(api.getByCodeType, params).then(res => {
        if (res.status === 200) {
          const imgTypeDatas = res.data
          this.tabsContent = []
          for (const item in imgTypeDatas) {
            imgTypeDatas[item].fileType = imgTypeDatas[item].codeCode
            imgTypeDatas[item].text = imgTypeDatas[item].codecname
            imgTypeDatas[item].state = false
            imgTypeDatas[item].show = false
            imgTypeDatas[item].active = false
            imgTypeDatas[item].src = []
            this.tabsContent.push(imgTypeDatas[item])
          }
          console.log(this.tabsContent, '影像排序数组===>')
          if (this.$store.state.entrance === 0) {
            console.log(this.$store.state.itemFileDataList, '已存在照片')
            this.fileIdList = []
            if (this.$store.state.itemFileDataList && this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList && this.$store.state.itemFileDataList[0].fileList.length > 0) {
              // 对已暂存的影像图片进行赋值
              this.$store.state.itemFileDataList[0].fileList.forEach(value => {
                const fileStreams = value.fileId
                const obj = {
                  path: fileStreams
                }
                for (const item in this.tabsContent) {
                  if (Number(value.fileType) === Number(this.tabsContent[item].codeCode)) {
                    this.tabsContent[item].src.push(obj)
                    this.tabsContent[item].state = true
                    this.tabsContent[item].active = true
                  }
                }
                const objs = {
                  fileId: value.fileId,
                  fileType: value.fileType
                }
                this.fileIdList.push(objs)
              })
            }
          }
        } else {
          this.$toast('获取影像排序失败')
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    share() {
      window.__proto__.once = 2
      const that = this
      that.showReload = true
      that.isWX = true
      const obj = []
      this.$store.state.insuredList.forEach(item => {
        console.log(item)
        obj.push({
          customIdNo: item.identifyNumber,
          customIdType: '01',
          customMobile: item.mobile,
          customName: item.insuredName,
          customType: 1
        })
      })
      document.querySelector('.wx').style.height =
        document.body.scrollHeight + 'px'

      window.addEventListener('scroll', function() {
        document.querySelector('.WXimg').style.position = 'fixed'
      })

      const URL = `${
        window.location.href.split('#')[0]
      }#/middleware?token=${localStorage.getItem('setToken')}&tname=${
        this.$store.state.insuredList[0].insuredName
      }&bname=${this.$store.state.insuredList[1].insuredName}&list=[${
        this.proList
      }]&orderId=${this.$store.state.orderId}&identifyNumber=${
        this.$store.state.insuredList[1].identifyNumber
      }&channelCode=DP_WXMP&params=${JSON.stringify(obj)}`
      console.log(URL)
      const shareUrl = encodeURI(URL)

      wx.ready(function() {
        // 分享给好友
        wx.updateAppMessageShareData({
          title: '车险报价', // 分享标题
          desc: '全面保障:请您阅读健康问询', // 分享描述
          link: shareUrl, // 分享链接
          imgUrl: that.shareLogo, // 分享图标
          success: function() {
            that.showReload = true
            // that.isWX = false;
          },
          cancel: function() {
            that.showReload = true
            // that.isWX = false;
          }
        })
      })
      wx.error(function(res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.log('进入这里了吗？', res)
      })
    },
    onConfirm(value) {
      this.popupVisible = false
      this.networkCode = value.code
    },
    // APP获取图片
    handleFiles(key) {
      PickImage.postMessage('pickImageBack')
      this.keys = key
    },
    pickImageBack(result) {
      const acquire = 'data:image/png;base64,' + result
      const name = new Date().getTime()
      const that = this
      const param = {
        fileBase64: acquire.replace(/^.*?,/, ''),
        fileName: name + '.png',
        fileType: that.tabsContent[that.keys].fileType,
        busType: 'dporder',
        filepath: '／' + that.tabsContent[that.keys].fileType
      }
      this.switchs = true
      that.$http
        .post(api.uploadFile, param)
        .then(res => {
          Toast.clear()
          if (res.data.rtnCode === '0000') {
            const path = {
              path: res.data.fileId
            }
            that.tabsContent[that.keys].src.push(path)
            const obj = {
              fileName: name + '.png',
              fileId: res.data.fileId,
              fileType: that.tabsContent[that.keys].fileType
            }
            that.fileIdList.push(obj)
            that.save(true, false)
          } else {
            that.$toast(res.data.rtnMsg)
          }
          this.switchs = false
        })
        .catch(error => {
          Toast.clear()
          console.log(error)
          this.switchs = false
        })
    },
    showMore(item, index) {
      if (item.active) {
        this.$set(item, 'active', false)
        item.state = false
        this.tabsContent[index].src = []
        const fileIdLists = []
        this.fileIdList.forEach(value => {
          if (value.fileType !== item.fileType) {
            fileIdLists.push(value)
          }
        })
        this.fileIdList = fileIdLists
        this.save(true, false)
      } else {
        this.$set(item, 'active', true)
        item.state = true
      }
    },
    handleFile(event, key) {
      const fileList = event.target.files
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size >= 20 * 1000 * 1000) {
          this.$toast('图片不能大于20M!')
        } else {
          if (!fileList[i]) return
          // 禁止的格式
          const forbidden = ['html', 'htm', 'svg'];
          const ext = fileList[i].name.toLowerCase().split('.').pop();
          if (forbidden.includes(ext)) {
            this.$toast('不支持上传 html/htm/svg 文件！')
            this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
            return
          }
          console.log(this.$refs.fileBtn, 'fileBtn')
          if (this.$refs.fileBtn) {
            this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
          }
          const reader = new FileReader()
          reader.readAsDataURL(fileList[i])
          const that = this
          reader.onload = function(e) {
            const param = {
              fileBase64: e.target.result.replace(/^.*?,/, ''),
              fileName: fileList[i].name,
              fileType: that.tabsContent[key].fileType
            }
            that.switchs = true
            that.$http
              .post(api.uploadFile, param)
              .then(res => {
                Toast.clear()
                if (res.data.rtnCode === '0000') {
                  const path = {
                    path: res.data.fileId
                  }
                  that.tabsContent[key].src.push(path)
                  const obj = {
                    fileName: fileList[i].name,
                    fileId: res.data.fileId,
                    fileType: that.tabsContent[key].fileType
                  }
                  that.fileIdList.push(obj)
                  that.save(true, false)
                } else {
                  that.$toast(res.data.rtnMsg)
                }
                that.switchs = false
              })
              .catch(error => {
                Toast.clear()
                console.log(error)
                that.switchs = false
              })
          }
        }
      }
    },
    // 单个图片删除
    IMGRemove(item, key, index) {
      this.fileIdList.forEach((value, indexs) => {
        if (value.fileId === item.path) {
          this.fileIdList.splice(indexs, 1)
        }
      })
      this.save(true, false)
      this.tabsContent[key].src.splice(index, 1)
    },
    goSpecial() {
      this.$router.push('clause')
    },
    // 暂存
    save(values, datas, val) {
      if (values) {
        if (datas) {
          if (!this.$store.state.engageLists) {
            this.$toast('请选择特别约定')
            return false
          }
        }
        this.switchs = true
      }
      const imageInfoLists = []
      this.fileIdList.forEach(value => {
        const objs = {
          fileId: value.fileId,
          fileType: value.fileType
        }
        imageInfoLists.push(objs)
      })
      const JQfile = {
        businessNo: 10501237000019000000,
        riskCode:
          localStorage.getItem('whetherFeeChangeArea') === '1' ? '050A' : '0501'
      }
      const data = {
        orderId: this.$store.state.orderId,
        terminalId: localStorage.getItem('setTerminalId'),
        orderOrigin: localStorage.getItem('setChannelCode'),
        channelCode: localStorage.getItem('setChannelCode'),
        itemFileDataList: [],
        terminalIdType: checkFormat.getPhoneLike(),
        submitInfo: {
          remark: this.remark
        }
      }
      if (imageInfoLists.length !== 0) {
        JQfile.fileList = imageInfoLists
        data.itemFileDataList.push(JQfile)
      }
      this.$http
        .post(api.save, data)
        .then(res => {
          if (values) {
            this.$store.commit(
              'setItemFileDataList',
              res.data.resultObj.itemFileDataList
            )
            // if (checkFormat.interpretation(this.$store.state.terminalId, this.$store.state.channelCode).terminalId === 'APP') {
            //   this.$store.commit('setOrderId', data.orderId)
            // }
            if (val === 1) {
              this.$toast('暂存成功')
            }
            this.switchs = false
          }
        })
        .catch(error => {
          console.log(error)
          if (values) {
            this.switchs = false
          }
        })
    },
    determination() {
      this.frame = false
      checkFormat.SolveThrough(false)
      // let userToken = localStorage.getItem('setToken')
      // let channelCode = localStorage.getItem('setChannelCode')
      // let terminalId = localStorage.getItem('setTerminalId'),
      // if (this.jumpStatus === 1) {
      //   let URL = window.location.href
      //   if (URL.indexOf('token') !== -1) { // 微店进入
      //     let orderId = this.$store.state.orderId
      //     location.href = `${process.env.API_HOST}/app/mall/m-web/?url=/Client/index#/Succeed?channelCode=${channelCode}&terminalId=${terminalId}&token=${userToken}&orderId=${orderId}`
      //   } else { // 官微\ 全员营销进入
      //     location.href = `${process.env.API_HOST}/app/mall/m-web/?url=/Client/index#/Order?channelCode=${channelCode}&terminalId=${terminalId}&token=${userToken}`
      //   }
      // }
    },
    // 提交核保
    goNext() {
      this.queryHis()
    },
    // 提交其他产品
    comfirm(val) {
      const arr = this.healthList.filter(item => {
        return item.status == false
      })
      const obj = {
        orderNo: val,
        productCodeList: []
      }
      if (arr.length > 0) {
        arr.forEach(item => {
          obj.productCodeList.push(item.productCode)
        })

        this.$http.post(api.deleteOnlineProducts, obj).then(res => {
          console.log(res)
        })
      }
    },
    // 上传影像信息
    submit() {
      this.ShowVandialog = false
      this.switchs = true
      const dataSet = {
        orderId: this.$store.state.orderId,
        engageList: this.$store.state.engageList,
        ordersAmount: this.$store.state.sumPremium,
        submitInfo: {
          remark: this.remark
        }
      }
      this.$http
        .post(api.submitUnderWrite, dataSet)
        .then(resA => {
          Toast.clear()
          console.log(resA.data.orderNo)
          if (resA.data.orderNo && this.flag) {
            this.comfirm(resA.data.orderNo)
            console.log('删除X产品')
          }
          if (resA.data.rtnCode === '0000') {
            // let URL = window.location.href
            // let receive = URL.split('?')[1].split('#')[0].split('&')
            // let orderId = false
            // receive.forEach(value =>{
            //   if (value.split('=')[0] === 'orderId') {
            //     orderId = true
            //   }
            // })
            // if (orderId) {
            //   this.$router.push({name:'Confirm'})
            // } else {
            //   console.log(this.$store.state.orderId, 'this.$store.state.orderId')
            //   this.$router.push({name:'Confirm',query:{orderId: this.$store.state.orderId, terminalId: localStorage.getItem('setTerminalId'), channelCode: localStorage.getItem('setChannelCode')}})
            // }

            // 可回溯修改 20200908 begin 因为只有提交核保成功，才能返回订单号保单号等信息，因此只有提交核保成功才调这个接口
            try {
              this.traceBack(resA.data).finally(() => {
                console.log('最后跳转')
                this.$router.push({
                  name: 'Confirm',
                  query: {
                    orderId: this.$store.state.orderId,
                    terminalId: localStorage.getItem('setTerminalId'),
                    channelCode: localStorage.getItem('setChannelCode')
                  }
                })
              })
            } catch (e) {
              this.$router.push({
                name: 'Confirm',
                query: {
                  orderId: this.$store.state.orderId,
                  terminalId: localStorage.getItem('setTerminalId'),
                  channelCode: localStorage.getItem('setChannelCode')
                }
              })
            }
            // 可回溯修改 end
            // this.$router.push({name:'Confirm',query:{orderId: this.$store.state.orderId, terminalId: localStorage.getItem('setTerminalId'), channelCode: localStorage.getItem('setChannelCode')}})
          } else if (resA.data.rtnCode === '9980') {
            // 核保中提示,点击确认跳转到订单列表页
            this.frame = true
            this.analysis = resA.data.rtnMsg
            this.jumpStatus = 1
            checkFormat.SolveThrough(true)
          } else {
            // 留在当前页
            this.frame = true
            this.analysis = resA.data.rtnMsg
            this.jumpStatus = 0
            checkFormat.SolveThrough(true)
          }
          this.switchs = false
        })
        .catch(error => {
          Toast.clear()
          console.log(error)
          this.switchs = false
        })
    },
    traceBack(data) {
      // data = {
      //   orderNo: '11',
      //   resultObj: {
      //     policyNo: '22'
      //   }
      // }
      return new Promise(resolve => {
        if (
          !data ||
          !data.orderNo ||
          !data.resultObj ||
          !(data.resultObj.policyNo || data.resultObj.policyNoCI)
        ) {
          resolve()
        }
        try {
          const productInfo = checkFormat.interpretation(
            localStorage.getItem('setTerminalId'),
            localStorage.getItem('setChannelCode')
          )
          const customers = this.getCustomers()
          const dataSet = {
            request: {
              applyTime: new Date().getTime(),
              campaignId: productInfo.orderOrigin,
              campaignName: '紫金车险',
              customer: customers,
              iseeBiz: '',
              orderNo: data.orderNo,
              policyNo: data.resultObj.policyNo || data.resultObj.policyNoCI,
              underwritingTime: new Date().getTime()
            }
          }
          const a = window.getIseeBiz()
          a.then(
            r => {
              console.log(r, '可回溯码')
              dataSet.request.iseeBiz = r
              this.$http.post(api.traceBackNew, dataSet).finally(() => {
                resolve()
              })
            },
            err => {
              resolve()
            }
          ).catch(() => {
            resolve()
          })
        } catch (e) {
          resolve()
        }
      })
    },
    getCustomers() {
      // 投保人
      const applicantIn = this.$store.state.applicantIn
      console.log(applicantIn, '投保人')
      // 被保人
      const recognizeeIn = this.$store.state.recognizeeIn
      console.log(recognizeeIn, '被保人')
      const insuredList = []
      if (applicantIn) {
        insuredList.push({
          customIdNo: applicantIn.identifyNumber,
          customType: '1',
          customMobile: applicantIn.mobile,
          customName: applicantIn.insuredName,
          customIdType: this.getZhongAnIdentifyType(applicantIn.identifyType)
        })
      }
      if (recognizeeIn) {
        insuredList.push({
          customIdNo: recognizeeIn.identifyNumber,
          customType: '2',
          customMobile: recognizeeIn.mobile,
          customName: recognizeeIn.insuredName,
          customIdType: this.getZhongAnIdentifyType(recognizeeIn.identifyType)
        })
      }
      return insuredList
    },
    getZhongAnIdentifyType(zkingIdentifyType) {
      switch (zkingIdentifyType) {
        // 个人-------------------
        // 身份证
        case '01':
          return '111'
        // 户口薄
        case '02':
          return '113'
        // 中国护照
        case '03':
          return '414'
        // 军官证
        case '04':
          return '114'

        // 驾驶执照
        case '05':
          return '335'
        // 返乡证
        case '06':
          return '516'
        // 外国护照 ?待确认
        case '07':
          return '414'
          // 企业-------------------

        // 统一社会信用代码
        case '13':
          return '822'
        // 税务登记证
        case '12':
          return '824'
        // 工商营业执照
        case '11':
          return '821'
        // 组织机构代码证
        case '10':
          return '823'

        // 其它
        case '99':
          return '990'
        default:
          return '990'
      }
    },
    // 健康问询状态刷新
    reload() {
      this.queryHis()
    },
    // orderId=8aaafc3f78e8d8fc0178ecba5de600f3&identifyNumber=1243434534
    // 渲染列表
    queryList() {
      //  let list=["0653","0657"]
      // console.log(list)
      this.healthList = []
      console.log(this.proTemp, '<===')
      this.proTemp.forEach(item => {
        // console.log(item)
        this.$http
          .post(api.queryHealthDetail, {
            productCode: item
          })
          .then(res => {
            if (res.data.rtnCode == '0000') {
              this.healthList.push({
                title: res.data.noticeName,
                status: '',
                icon: false,
                context: res.data.result,
                productCode: item,
                times: 0,
                productName: res.data.productName
              })
            }
          })
      })
    },
    // 查询状态
    queryHis() {
      const businessNo = this.$store.state.orderId
      this.$http
        .post(api.queryOrderHealthRiskInfo, {
          businessNo,
          channelCode: 'DP_WXMP',
          flag: 1,
          // identifyNumber: util.getUrlKey('identifyNumber'),
          pageNo: 0,
          pageSize: 100
          // productCode: "ZKICATM_LIFE",
        })
        .then(res => {
          // 回显图标效果
          if (res.data.content) {
            if (res.data.content[0]) {
              const result = JSON.parse(res.data.content[0].questionnaireRecord)
              result.forEach((item, index) => {
                this.healthList.forEach((key, val) => {
                  if (item.productCode == key.productCode) {
                    key.status = item.status
                    key.times = item.times
                    if (item.status == '1' || item.status == '0') {
                      key.icon = true
                    } else {
                      key.icon = false
                    }
                  }
                })
              })
            }
          }
        })
        .then(() => {
          let text = ''
          if (!this.$store.state.engageLists) {
            this.$toast('请选择特别约定')
            return false
          } else {
            // this.save(false, false)
            // 过滤不符合的数据
            const arr = this.healthList.filter(item => {
              return item.status == 0
            })
            console.log(arr, '不符合的')

            if (arr.length > 0) {
              this.ShowVandialog = true
              arr.forEach(item => {
                console.log(item)
                text += `${item.title} ,`
              })
              this.dialogText = text
              // 提交其他的产品  待补充
              this.flag = true
            } else {
              this.dialogText = ''
              this.ShowVandialog = false
              // 提交全部  待补充
              this.flag = false
              console.log(this.healthList, '提交全部<===')
              this.submit()
            }
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./supplementary.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/supplementary/index.vue